module.exports = __webpack_public_path__ + "1.4.15-unryo/img/opsgenie.76eda222.png";